import { render, staticRenderFns } from "./InvoicePositions.vue?vue&type=template&id=3c01e98b&scoped=true"
import script from "./InvoicePositions.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicePositions.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicePositions.vue?vue&type=style&index=0&id=3c01e98b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c01e98b",
  null
  
)

export default component.exports